import React, { useContext, useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import $ from "jquery";
import { AppContext } from "./store";
import { ActionType } from "../@types";

export const TealiumHandler: React.FunctionComponent = ({ children }) => {
  const { dispatch } = useContext(AppContext);
  const [insertUtag, setInsertUtag] = useState(false);
  const { feEnableTealium } = useFlags();
  const [script1Inserted, setScript1Inserted] = useState(false);
  const [script2Inserted, setScript2Inserted] = useState(false);
  const [script3Inserted, setScript3Inserted] = useState(false);

  useEffect(() => {
    if (feEnableTealium) {
      /* istanbul ignore next: built-in functionality */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.jQuery = $;
      /* istanbul ignore next: built-in functionality */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.$ = $;

      setInsertUtag(true);
    }
  }, [feEnableTealium]);

  useEffect(() => {
    if (insertUtag) {
      if (!script1Inserted) {
        const script1 = document.createElement("script");
        script1.innerHTML =
          "var utag_data; window.utag_cfg_ovrd = { noview: true };";
        script1.type = "text/javascript";
        document.head.appendChild(script1);
        setScript1Inserted(true);
      }

      if (!script2Inserted) {
        const script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.src =
          "//tags.tiqcdn.com/utag/cmsgov/medicare-www/prod/utag.sync.js";
        script2.defer = true;
        document.head.appendChild(script2);
        setScript2Inserted(true);
      }

      if (!script3Inserted) {
        const regEx = /^(www|es|enrollmentcenter|plancompare|csr).medicare.gov/;
        const environment = regEx.test(window.location.hostname)
          ? "prod"
          : "dev";
        const scriptName = `//tags.tiqcdn.com/utag/cmsgov/medicare-www/${environment}/utag.js`;
        const script3 = document.createElement("script");
        script3.src = scriptName;
        script3.type = "text/javascript";
        script3.async = true;
        script3.onload = (): void => {
          dispatch({
            type: ActionType.SET_TEALIUM_LOADED,
            payload: true,
          });
        };
        document.body.appendChild(script3);
      }
      setScript3Inserted(true);
    }
  }, [insertUtag]);

  return (
    <>
      {insertUtag && (
        <span
          id="app-utag1"
          data-testid="app-utag1"
          className="ds-u-display--none"
        >
          Tealium Enabled
        </span>
      )}
      {children}
    </>
  );
};

export default TealiumHandler;
